module.exports = __webpack_public_path__ + "static/HRportalMobile-b0a721806ac04fe5121778295806e5f2.png";